"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CATALOGUES_LANDING_PAGE = void 0;
const CATALOGUES_LANDING_PAGE = exports.CATALOGUES_LANDING_PAGE = 'catalogues-landing-page';
